<template>
    <div
      class="modal fade createNewModal"
      id="AddElementModal"
      tabindex="-1"
      ref="addElementModalRef"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-15 p-md-40">
          <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
            <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
          </div>
          <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
            <Form ref="elementForm" @submit="addElement" :validation-schema="elementSchema">
                
                <div class="row">

                  <div class="col-md-12">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                      Nom <span class="text-danger">*</span>
                      </label>
                      <Field name="nom" type="text" 
                      class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le libelle"/>
                      <ErrorMessage name="nom" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-12">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                      Désignation <span class="text-danger">*</span>
                      </label>
                      <Field name="designation" type="text" 
                      class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer la designation"/>
                      <ErrorMessage name="designation" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-12">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Type d'actualité
                      </label>
                      <Field name="typeActualite" v-model="typeActualiteSelected"  v-slot="{ field }">
                        <Multiselect
                            v-model = "field.value"
                            v-bind = "field"
                            :options="typeActualiteOptions"
                            :searchable="true"
                            placeholder="Rechercher un element"
                            noResultText= "Aucun enregistrement trouvé"
                            noOptionsText="Tapez au moins deux caractères"/>
                      </Field>
                      <ErrorMessage name="typeActualite" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-6" v-if="typeActualiteSelected == 'PROMOTION'">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Type de Remise
                      </label>
                      <Field name="typeRemise" v-model="typeRemiseSelected"  v-slot="{ field }">
                        <Multiselect
                            v-model = "field.value"
                            v-bind = "field"
                            :options="typeRemiseOptions"
                            :searchable="true"
                            placeholder="Rechercher un element"
                            noResultText= "Aucun enregistrement trouvé"
                            noOptionsText="Tapez au moins deux caractères"/>
                      </Field>
                      <ErrorMessage name="typeRemise" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-6" v-if="typeActualiteSelected == 'PROMOTION'">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                      Valeur <span class="text-danger">*</span>
                      </label>
                      <Field name="valeurRemise" type="text" 
                      class="form-control shadow-none fs-md-15 text-black" placeholder="La valeur de la remise"/>
                      <ErrorMessage name="valeurRemise" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                        Date Début
                    </label>
                    <Field name="dateDebutPromotion" type="date"  :value="getCurrentDate()"
                    class="form-control shadow-none fs-md-15 text-black"/>
                    <ErrorMessage name="dateDebutPromotion" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                        Date Fin
                    </label>
                    <Field name="dateFinPromotion" type="date"  :value="getCurrentDate()"
                    class="form-control shadow-none fs-md-15 text-black"/>
                    <ErrorMessage name="dateFinPromotion" class="text-danger"/>
                  </div>
                  </div>


                  <div class="col-md-12 mt-10">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Image <span class="text-danger">*</span>
                      </label>
                      <Field
                        name="urlImage"
                        type="file"
                        accept="image/jpeg, image/png, image/png application/pdf"
                        class="form-control shadow-none fs-md-15 text-black"
                        placeholder="Choisir une image"
                      />
                      <ErrorMessage name="urlImage" class="text-danger" />
                    </div>
                  </div>



                </div>
                
              
              <button
                class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
                type="submit">
                {{ btntext }}
              </button>
          </Form>
          </div>
          <button
            type="button"
            class="btn-close shadow-none"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="resetValue()"
          ></button>
        </div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, ref, watch, onMounted } from 'vue';
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import ApiService from '../../services/ApiService';
  import * as Yup from 'yup';
  import path from 'path-browserify';
  import { error , success, hideModal } from '../../utils/utils';
  import Multiselect from '@vueform/multiselect';
import { Actualite } from '@/models/Actualite';
import axios from 'axios';
  
  export default defineComponent({
      name: "AddActualiteModal",
      components: {
      Form,
      Field,
      ErrorMessage,
      Multiselect
    },
    props: {
      item: {
        type: Number,
        default: 0,
      }
    },
    setup(props, { emit }){

      const typeActualiteSelected = ref(null);

      const elementSchema = Yup.object().shape({
        nom: Yup.string().required('Le libelle est obligatoire'),
        designation: Yup.string().required('La designation est obligatoire'),
        typeActualite: Yup.string().required(`Le type d'Actualité est obligatoire`),
        typeRemise: (typeActualiteSelected.value == 'PROMOTION') ? Yup.string().required('Le type de remise est obligatoire') : Yup.string().notRequired(),
        valeurRemise : (typeActualiteSelected.value == 'PROMOTION') ? Yup.number().required('La valeur de la remise est obligatoire') : Yup.number().notRequired(),
        dateDebutPromotion: Yup.date().required('La date de début est obligatoire'),
        dateFinPromotion: Yup.date().required('La date de fin est obligatoire'),
        urlImage: Yup.mixed().required("L'image est obligatoire"),
      });
  
      
      const elementForm = ref<Actualite | null>(null);
      const addElementModalRef = ref<null | HTMLElement>(null);
      const categorieSelected = ref(null);
      const typeRemiseSelected = ref(null);
      
      const categorieOptions = ref([]);
      const typeActualiteOptions = {
        "ANNONCE":"ANNONCE",
        "PROMOTION":"PROMOTION"
      };
      const typeRemiseOptions = {
        "%":"POURCENTAGE",
        "VALEUR":"VALEUR"
      };
      
      const isUPDATE = ref(false);
      const title = ref("Ajouter une actualité");
      const btntext = ref('Enregistrer');
  
      watch(() => props.item, (newValue) => {
        getOne(newValue);
        isUPDATE.value = true;
        btnTitle();
      });

      // ok

      // ok fin
  
      const btnTitle = async () => {
        if (isUPDATE.value) {
           title.value = "Modifier l'actualité";
           btntext.value = "Modifier";
        }else{
           title.value = "Ajouter une actualité";
           btntext.value = "Enregistrer";
        }
      } 

      const getCurrentDate = () => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const year = today.getFullYear();
        return `${year}-${month}-${day}`;
      }
  
  
     
      const getOne = async (id: number) => {
        console.log("getOne", id);
        return ApiService.get("/actualite/"+id)
        .then(({ data }) => {
          // map data in form
          const donnees = data.data;
          // const categories = donnees.categories;
  
          // let ids: number[] = [];
          // for (const categorie of categories) {
          //   ids.push(categorie.id); 
          // }
          // categories.value= ids;
  
          // defaultSelectedCategories.value = categories.value
          for (const key in donnees) {
            elementForm.value?.setFieldValue(key, 
            (typeof donnees[key] === 'object' && donnees[key] !== null)? donnees[key].id :donnees[key]
            );
          }
          emit('openmodal', addElementModalRef.value);
  
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
      }


      const fetchFormules = async () => {
          ApiService.get("/formules")
          .then(({ data }) => {
            categorieOptions.value = data.data.map((p) => {
                return { 
                  value: p.id,
                  label: p.libelle,
                }
            });
          })
          .catch(({ response }) => {
            // produitsError.value = true;
          });
      };

  
      const addElement = async (values: any, elementForm) => {
        
        values = values as Actualite;
        if(isUPDATE.value){
          ApiService.put("/actualite/"+values.id,values)
          .then(({ data }) => {
              if(data.code == 200) { 
                success(data.message);
                elementForm.resetForm();
                hideModal(addElementModalRef.value);
                isUPDATE.value=false;
                btnTitle();
                emit('close');
              }
          })
          .catch(({ response }) => {
              error(response.data.message);
          });
        }else{
          axios.post('/actualite', values, {
              headers: { "Content-Type": "multipart/form-data", Accept: "*/*" }
          })
          // ApiService.post("/actualite",values)
          .then(({ data }) => {
              if(data.code == 201) { 
                success(data.message);
                elementForm.resetForm();
                hideModal(addElementModalRef.value);
                emit('close');
              }
          })
          .catch(({ response }) => {
              error(response.data.message);
          });
        }
      };
     
  
      onMounted(() => {
        fetchFormules();
      });
  
      const resetValue = () => {
        const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
          isUPDATE.value=false;
        formFields.forEach(field => {
          field.value = '';
        });
        btnTitle()
      };
  
      return { 
        elementSchema,
        addElementModalRef,
        addElement,
        elementForm,
        title,btntext,
        resetValue,
        getCurrentDate,
        typeActualiteOptions,
        typeRemiseOptions,
        typeRemiseSelected,
        typeActualiteSelected,
        // dropzoneOptions,
        // onFileAdd,
        // toutFichier,
        // hasFiles,
        // defaultImage,
        // onFileRemove
      };
    },
  });
  </script>

  <style scoped >

    .upload-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
    }

  </style>